import { render, staticRenderFns } from "./SidebarCheckout.vue?vue&type=template&id=b3d72f0c"
import script from "./SidebarCheckout.js?vue&type=script&lang=js&external"
export * from "./SidebarCheckout.js?vue&type=script&lang=js&external"
import style0 from "./SidebarCheckout.vue?vue&type=style&index=0&id=b3d72f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports